<form [formGroup]="tad_applicant_address_form">
  <fieldset class="form-group">
    <legend>Which one of these is you?</legend>
    <div class="c-radio--list custom-controls-stacked">
      @for (address of address_results; track address) {
        <span class="c-radio-button">
          <label class="custom-control custom-radio">
            <input id="tad_applicant_address_result" formControlName="tad_applicant_address_result" name="tad_applicant_address_result" type="radio" class="custom-control-input" [value]="address.PtcAbsCode">
            <span class="custom-control-indicator"></span>
            <span class="custom-control-description">{{address.fullAddress}}</span>
          </label>
        </span>
      }
    </div>
  </fieldset>
</form>